import { Button, Card, Col, Row } from "antd";
import { useSelector } from "react-redux";
import styles from "./index.module.scss";
import { CssSpriteNames } from "utils/staticObject";
import "./index.scss";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

const ConnectedAppComponent = () => {
  // const {data,isLoading} = useSelector((state: any) => {
  //   return state?.companies;
  // });

  const { isLoading } = useSelector((state: any) => {
    return state?.companies;
  });

  const [companyName, setCompanyName] = useState<string>("");

  useEffect(() => {
    const freshbookCompany = localStorage.getItem("freshbookCompany");
    if (freshbookCompany) {
      try {
        const parsed = JSON.parse(freshbookCompany);
        if (parsed) {
          setCompanyName(parsed);
        }
      } catch (error) {
        console.error("Invalid freshbookCompany JSON");
      }
    } else {
      const stored = localStorage.getItem("callbackResponse");
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          console.log("parsed: ", parsed);
          if (parsed?.companyName) {
            setCompanyName(parsed.companyName);
          }
        } catch (error) {
          console.error("Invalid callbackResponse JSON");
        }
      }
    }
  }, []);

  return !isLoading ? (
    <div className={styles["connetedapps"]}>
      <span className={styles["connetedapps__title"]}>
        {/* You are connected with {data?.companyName} */}
        You are connected with {companyName}
      </span>
      <div className={styles["connetedapps__images"]}>
        <Row justify={"center"} gutter={25}>
          <Col
            // span={6}
            xs={24}
            md={8}
            lg={6}
            sm={12}
            style={{ marginBottom: 12 }}
          >
            <Card bordered={true} className={`card conneted`}>
              <div
                className={
                  styles[
                    `bg-${
                      CssSpriteNames[
                        localStorage.getItem(
                          "integration"
                        ) as keyof typeof CssSpriteNames
                      ]
                    }`
                  ]
                }
              >
                {" "}
              </div>
              <div className="right-mark">
                <CheckCircleOutlined
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    margin: "8px",
                    color: "green",
                  }}
                />
              </div>
            </Card>
          </Col>
        </Row>
        <Row justify={"center"}>
          <Button
            className={`${styles["connetedapps__connectbtn"]} edit`}
            onClick={() => {
              window.close();
              localStorage.removeItem("callbackResponse");
              localStorage.removeItem("freshbookCompany");
            }}
          >
            Finish
          </Button>
        </Row>
      </div>
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <img
        src={`${process.env.REACT_APP_IMAGES_BASE_URL}/assets/gifs/loading.gif`}
        height={60}
        crossOrigin={
          process.env.REACT_APP_ENV === "local" ? undefined : "anonymous"
        }
      />
    </div>
  );
};

export default ConnectedAppComponent;
